import { useAppSettings } from "@api/appSettings";
import { useUserProfile } from "@api/auth";
import axios from "@api/axiosInstance";
import FullPageLoading from "@components/FullPageLoading";
import LoginPage from "@features/auth/components/LoginPage/LoginPage";
import TermsAndConditionsPage from "@features/auth/components/TermsAndConditionsPage/TermsAndConditionsPage";
import useAppStore from "@hooks/useAppStore";
import useUserPermissionStore from "@hooks/useUserPermissionStore";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

const withAuth = (WrappedComponent: any) => {
  console.log("WithAuth");

  return (props: any) => {
    const appStore = useAppStore();
    const upStore = useUserPermissionStore();
    const userProfile = useUserProfile();

    useEffect(() => {
      // TODO: move this to appStore and inject it into axiosInstance
      if (userProfile.isSuccess) {
        localStorage.setItem("accessToken", userProfile.data?.token?.accessToken || "");
        appStore.setUserProfile(userProfile.data?.userProfile!);
        appStore.setAuthenticated(true);
      }
    }, [userProfile.data]);

    useEffect(() => {
      if (userProfile.error !== null) {
        const path = window.location.pathname;
        if (path !== "/" && path !== "/terms") {
          window.location.href = "/";
        }
      }
    }, [userProfile.error]);

    useEffect(() => {
      axios.interceptors.response.use(
        (response: any) => {
          upStore.setPermission(response?.headers?.jwttoken || "");
          return response;
        },
        (error: any) => {
          return Promise.reject(error);
        },
      );
    }, [upStore]);

    if (window.location.pathname === "/api/auth/signin") {
      console.log("WithAuth /api/auth/signin");

      return <></>;
    }

    if (appStore.isAuthenticated) {
      return <WrappedComponent {...props} />;
    }

    if (userProfile.isLoading) {
      return <FullPageLoading />;
    }

    return (
      <Routes>
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  };
};

export default withAuth;
